


export const filterByOptions = [
  { label: 'Publication Year', id:0},
  { label: 'Publication Year Range', id:1},
	{ label: 'Author Full Name', id:2}, 
  { label: 'Author Given Name', id:8}, 
  { label: 'Author Family Name', id:9}, 
	{ label: 'Title', id:3},
	{ label: 'Venue', id:4},
	{ label: 'DOI', id:5},
	{ label: 'Has Abstract Parsed', id:6},
	{ label: 'Has Fullbody Parsed', id:7},
];

const rangeFilterOptions = [
  filterByOptions[1]
].map(f => f.label);

const nonBoolFilterOptions = [
  filterByOptions[0], 
  filterByOptions[1],
  filterByOptions[2],
  filterByOptions[3],
  filterByOptions[4],
  filterByOptions[5],
  filterByOptions[6],
  filterByOptions[7],
].map(f => f.label);


const boolFilterOptions = [
  filterByOptions[8], 
  filterByOptions[9]
].map(f => f.label);


export const conditionOptions = [
  {  id:0, label: 'IS' , label2: 'CONTAINS'},
	{  id:1, label: 'IS NOT', label2: 'EXCLUDES' },
];

export const filterParser = (filter) => {
  let condition = ""
  if (filter.condition === conditionOptions[0].label) {
    condition = ""
  } else {
    condition = "!"
  }
  if (filter.filterBy === 'Publication Year') {
    if (filter.value.length === 0) return ""
    return `${condition}PublicationDate.Year:${filter.value.join('|')}`

  } else if (filter.filterBy === 'Publication Year Range') {
    const minYear = Math.min(...filter.value.map(v => parseInt(v)));
    const maxYear = Math.max(...filter.value.map(v => parseInt(v)));
    return `${condition}PublicationDate.Year:${minYear}..${maxYear}`

  } else if (filter.filterBy === 'Author Full Name') {
    if (filter.value.length === 0) return ""
    return `${condition}Author.FullName:${filter.value.join('|')}` 
  
  } else if (filter.filterBy === 'Author Given Name') {
    if (filter.value.length === 0) return ""
    return `${condition}Author.GivenName:${filter.value.join('|')}`
  
  } else if (filter.filterBy === 'Author Family Name') {
    if (filter.value.length === 0) return ""
    return `${condition}Author.FamilyName:${filter.value.join('|')}` 

  } else if (filter.filterBy === 'Title') {
    if (filter.value.length === 0) return ""
    return `${condition}Title:${filter.value.join('|')}` 

  } else if (filter.filterBy === 'Venue') {
    if (filter.value.length === 0) return ""
    return `${condition}Venue:${filter.value.join('|')}` 

  } else if (filter.filterBy === 'DOI') {
    if (filter.value.length === 0) return ""
    return `${condition}DOI:${filter.value.join('|')}` 

  } else if (filter.filterBy === 'Has Abstract Parsed') {
    if (filter.value === 'false') {
      condition = "!"
    } else {
      condition = ""
    }
    return `${condition}AvailableField:Content.Abstract_Parsed`

  } else if (filter.filterBy === 'Has Fullbody Parsed') {
    if (filter.value === 'false') {
      condition = "!"
    } else {
      condition = ""
    }
    return `${condition}AvailableField:Content.Fullbody_Parsed`

  } else {
    return ''
  }
} 


export const isFilterValid = (filter) => {
  // Define the required fields
  const requiredFields = ["condition", "filterBy", "value"];
  const allowedFilterBys = filterByOptions.map(option => option.label);

  // Check if all required fields are present and not empty
  for (const field of requiredFields) {
    if (!Object.prototype.hasOwnProperty.call(filter, field) || filter[field] === undefined || filter[field] === null) {
      return false;
    }
  }

  // Check if filterBy has a valid value
  if (!allowedFilterBys.includes(filter.filterBy)) {
    return false;
  }

  // Check for valid value types depending on the filterBy option
  if (nonBoolFilterOptions.includes(filter.filterBy)) {
    if (!Array.isArray(filter.value) || filter.value.length === 0) {
      return false;
    }
  } else if (boolFilterOptions.includes(filter.filterBy)) {
    if (typeof filter.value !== "string" || (filter.value !== "true" && filter.value !== "false")) {
      return false;
    }
  }

  return true;
};


// Filters in the Publication Year Range have [Int] values which is not consistent of the [String] type
// use the encodeFilter and the decode to change that
export const encodeFilter = (filter) => {
  // If Publication Year Range
  if (rangeFilterOptions.includes(filter.filterBy)) {
    const minYear = `${filter.value[0]}`
    const maxYear = `${filter.value[1]}`
    return {filterBy: filter.filterBy, condition: filter.condition, value: [minYear, maxYear]}
  }
  // If  Has Abstract Parsed or Has Fullbody Parsed
  else if (boolFilterOptions.includes(filter.filterBy)) {
    return {filterBy: filter.filterBy, condition: filter.condition, value: [filter.value]}
  }

  return filter;
};

export const decodeFilter = (filter) => {
  // If Publication Year Range
  if (rangeFilterOptions.includes(filter.filterBy)) {
    const minYear = parseInt(filter.value[0])
    const maxYear = parseInt(filter.value[1])
    return {filterBy: filter.filterBy, condition: filter.condition, value: [minYear, maxYear]}
  }
  // If  Has Abstract Parsed or Has Fullbody Parsed
  else if (boolFilterOptions.includes(filter.filterBy)) {
    return {filterBy: filter.filterBy, condition: filter.condition, value: filter.value[0]}
  }

  return filter;
};